export default __webpack_public_path__ + "static/media/product18.4e87bb36.png";